import React from 'react'
import { Modal } from 'react-bootstrap';
import OrderType from '../../../components/ItemGrid/OrderType';
import { IItemPathToRoute } from '../../../models/item.model';

interface ILocationSelectionModalProps {
    isOrderTypeSelected:boolean;
    openOrderModal:boolean;
    closeOpenOrderModal:() => void;   
    itemPath:IItemPathToRoute
}

const LocationSelectionModal:React.FC<ILocationSelectionModalProps> = ({isOrderTypeSelected,openOrderModal,closeOpenOrderModal, itemPath}) => {
    return (
        <React.Fragment>
            {!isOrderTypeSelected ?
                (
                    <Modal
                        show={openOrderModal}
                        centered
                        className="theme-modal-style app_container_wrap  border-radius-15 px-5 order_type_modal"
                        onHide={closeOpenOrderModal}
                    >
                        <Modal.Header className="x-4 justify-content-center">
                            <button
                                type="button"
                                className="btn modal-close-button pe-0"
                                onClick={closeOpenOrderModal}
                            >
                                Close
                            </button>
                        </Modal.Header>
                        <Modal.Body>
                            <OrderType handleOrderTypeModal={closeOpenOrderModal} itemPath={itemPath}/>
                        </Modal.Body>
                    </Modal>
                ) : ""
            }
        </React.Fragment>
    )
}

export default LocationSelectionModal